import { createContext } from 'react';

export type ScenarioListContextType = {
  removeScenario: (scenarioId: string) => void;
};

export const ScenarioListContext = createContext<ScenarioListContextType>({
  removeScenario: () => null,
});
